import { registerBlocklyFields } from '@shared/blockly/fields';
import { FieldChevron } from './field-chevron';
import { FieldIcon } from './field-icon';
import { FieldJsonModal } from './field-json-modal';
import { FieldMultilineModal } from './field-multiline-modal';
import { FieldPlusMinus } from './field-plus-minus';
import { FieldVariableActions } from './field-variable-actions';

registerBlocklyFields({
  field_icon: FieldIcon,
  field_chevron: FieldChevron,
  field_json_modal: FieldJsonModal,
  field_multiline_modal: FieldMultilineModal,
  field_variable_actions: FieldVariableActions,
  field_plus_minus: FieldPlusMinus,
});
